const ComponentBase = require('../../base/ComponentBase');
const BaseLayerProviders = require('./BaseLayerProviders');
const CommonUtil = require('../../utils/CommonUtil');
const LayerUtil = require('../../utils/LayerUtil');
const extend = require('../../base/util/Extend');
/**
 * @constructor
 * @classdesc 底图切换组件
 * @augments G.base.ComponentBase
 * @alias G.common.SwitchBaseLayer
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {Array} options.layers 底图数组
 * @param {String} options.layers[i].id 底图标识
 * @param {String} options.layers[i].name  底图名称
 * @param {Boolean} options.layers[i].visible 是否默认显示
 * @param {Array} options.layers[i].layers 底图图层数组
 * @example
 * var opts ={
 *     map:demo.emap,
 *     layers:[
 *         {
 *             id:"baselayer01",
 *             name:"baselayer01",
 *             visible:true,
 *             layers:[
 *                 G.common.BaseLayerProviders.TIANDITU.VEC_C,
 *                 G.common.BaseLayerProviders.TIANDITU.CTA_C
 *             ]
 *         },
*         {
 *             id:"baselayer02",
 *             name:"baselayer02",
 *             layers:[
 *                 G.common.BaseLayerProviders.extend("TIANDITU.IMG_C",{token:"4f62e1d82bd46e2ff470b291c2260156"})
 *             ]
 *         }
 *     ]
 * }
 * var switchBaseLayer = new G.common.SwitchBaseLayer(opts);
 * //加载
 * switchBaseLayer.load();
 * //显示底图
 * switchBaseLayer.show("baselayer01");
 * //卸载，清除所有图层
 * switchBaseLayer.unload();
 */

let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        //
        this.list = options.layers || [];
        this.layers = [];
    },
    /**
     * @inheritDoc
     */
    load() {
        for (let i = 0; i < this.list.length; i++) {
            let layer = this._createBaseLayer(this.list[i]);
            layer.setVisible(!!this.list[i].visible);
            this.map.addLayer(layer);
            this.layers.push(layer);
        }
    },
    /**
     * @inheritDoc
     */
    destroy() {
        //
        ComponentBase.prototype.destroy.call(this);
    },
    /***
     * @inheritDoc
     */
    unload: function () {
        this.clear();
    },

    /**
     * 显示底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     * @param id {String} 底图id
     * @param exclusive {Boolean} 是否排他，true时隐藏其他底图
     */
    showLayer(id, exclusive) {
        if (!!exclusive) {
            for (let i = 0; i < this.layers.length; i++) {
                this.layers[i].setVisible(this.layers[i].id === id);
            }
        } else {
            for (let i = 0; i < this.layers.length; i++) {
                if (this.layers[i].id === id) {
                    this.layers[i].setVisible(true);
                    break;
                }
            }
        }
    },

    /**
     * 隐藏底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     * @param id {String} 底图id
     */
    hideLayer(id) {
        for (let i = 0; i < this.layers.length; i++) {
            if (this.layers[i].id === id) {
                this.layers[i].setVisible(false);
                break;
            }
        }
    },

    /**
     * 隐藏所有底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     */
    hideAll() {
        for (let i = 0; i < this.layers.length; i++) {
            this.layers[i].setVisible(false);
        }
    },
    /**
     * 隐藏所有底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     * @param id {String} 根据id获取图层
     */
    getLayerById(id) {
        //todo
    },
    /**
     * 获取当前显示的底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     */
    getCurrentLayers() {
        //todo
    },
    /**
     *
     */
    getLayers() {
        return this.layers;
    },

    /**
     * 添加底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     * @param opts {Object} 底图配置
     */
    addLayer(opts) {
        if (this._checkLayerOpts(opts)) {
            this.list.push(opts);
            //add layer to map
            let layer = this._createBaseLayer(opts);
            this.map.addLayer(layer);
            this.layers.push(layer);
            //
            this._updateOnChange();
        }
    },

    /**
     * 移除底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     * @param id {String} 底图id
     */
    removeLayer(id) {
        let removed = this._removeLayerById(id);
        if (removed != null) {
            this._updateOnChange();
        }
        return removed;
    },

    /**
     * 清除所有底图
     * @method
     * @memberOf G.common.SwitchBaseLayer.prototype
     */
    clear() {
        for (let i = 0; i < this.layers.length; i++) {
            this.map.removeLayer(this.layers[i]);
        }
        this.layers = [];
        this.list = [];
    },
    //创建底图
    _createBaseLayer(opts) {
        let layer = null;
        opts = extend(true, {}, opts);
        this._handleToken(opts);
        if (opts.layers.length > 1) {
            let layerOpts = extend(true, {}, opts);
            layerOpts.type = 'group';
            layer = LayerUtil.createBaseLayer(layerOpts);
        } else {
            let layerOpts = extend(true, {}, opts.layers[0]);
            layerOpts.id = opts.id;
            layerOpts.name = opts.name;
            layer = LayerUtil.createBaseLayer(layerOpts);
        }
        return layer;
    },

    _removeLayerById(id) {
        let removed = null;
        for (let i = this.list.length - 1; i >= 0; i--) {
            if (this.list[i].id === id) {
                removed = this.list[i];
                this.list.splice(i, 1);
                let layer = this.layers[i];
                this.map.removeLayer(layer);
                this.layers.splice(i, 1);
                break;
            }
        }
        return removed;
    },
    //检查底图参数
    _checkLayerOpts(opts) {
        let flag = true;
        //todo
        //检查参数，不合格则抛出异常
        return flag;
    },
    _handleToken(opts) {
        for (let i = 0; i < opts.layers.length; i++) {
            let layerOpt = opts.layers[i];
            if (layerOpt.token) {
                layerOpt.url = layerOpt.url.replace('{token}', layerOpt.token);
            }
        }
    },
    _updateOnChange() {
        //todo 底图变化后的处理
    }
});
module.exports = component;
